

<template>
  <div>
    <div class="baic_content">
      <h3></h3>
      <div class="back_view" v-if="isedite == 2">
        <h5 class="vip_view">视频名称:</h5>
        <p>
          {{ $parent.$parent.videoinfo.VideoName }}
        </p>
      </div>
      <div class="bacle_input" v-else>
        <h5>视频名称:</h5>
        <el-input
          type="textarea"
          placeholder="请输入视频名称"
          v-model.trim="textarea"
          maxlength="30"
          show-word-limit
          resize="none"
          class="check_textarea"
          :disabled="isedite == 1 || isedite == 2"
        >
        </el-input>
      </div>
      <div class="back_view" v-if="isedite == 2">
        <h5 class="vip_view">上传视频:</h5>
        <p>
          {{ $parent.$parent.videoinfo.VideoName + "课件" }}
        </p>
      </div>
      <div class="bacle_input" v-if="isedite == 0">
        <h5>上传视频:</h5>
        <el-input
          :placeholder="filename"
          v-model="textFile"
          class="check_input"
          readonly
        ></el-input>
        <el-upload
          class="upload-demo"
          ref="upload"
          action=""
          multiple
          :limit="1"
          :before-upload="getVideoToken"
          :show-file-list="false"
          :http-request="uploadPreview"
        >
          <el-button type="primary" icon="el-icon-upload2" class="upoload"
            >上传视频</el-button
          >
        </el-upload>
        <p class="upload_type" @click="toDocument">
          可以上传什么格式的视频呢？
        </p>
      </div>
      <div class="back_view" v-if="isedite == 2">
        <h5 class="vip_view">视频开放时间:</h5>
        <p>
          {{
            opentime(
              $parent.$parent.videoinfo.BeginTime,
              $parent.$parent.videoinfo.EndTime
            )
          }}
        </p>
      </div>
      <div class="bacle_input" v-else>
        <h5>视频开放时间:</h5>
        <el-date-picker
          :disabled="isedite == 2"
          class="datescope"
          v-model="value1"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm"
          :picker-options="$route.query.trainId ? pickerOptions : pickerOptions0"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @focus="obtainTime"
          :default-time="[vehicleTime, '23:59:00']"
        >
        </el-date-picker>
      </div>
      <div class="back_view" v-if="isedite == 2">
        <h5 class="mg_40">格式大小:</h5>
        <p>
          {{
            filesize(
              $parent.$parent.videoinfo.Format,
              $parent.$parent.videoinfo.FileSize
            )
          }}
        </p>
      </div>
      <div class="back_view" v-if="isedite == 2">
        <h5 class="mg_40">上传时间:</h5>
        <p>
          {{
            $moment($parent.$parent.videoinfo.CreateTime).format(
              "YYYY/MM/DD HH:mm"
            )
          }}
        </p>
      </div>
      <div class="back_view" v-if="isedite == 2">
        <h5 class="mg_40">上传者:</h5>
        <p>
          {{ $parent.$parent.videoinfo.RealName }}
        </p>
      </div>
      <div class="bacle_input">
        <h5 class="nonecessary">视频简介:</h5>
        <el-input
          type="textarea"
          placeholder="请输入视频名称"
          v-model.trim="textproduce"
          maxlength="500"
          show-word-limit
          resize="none"
          class="check_produce"
          :readonly="isedite == 2"
        >
        </el-input>
      </div>
      <div class="learning_time" v-if="!$route.query.trainId">
        <h5 class="vip_view">视频最低学习时长要求:</h5>
        <div class="input_time">
          <el-input
            v-model.number="timeValue"
            placeholder="请输入视频学习时长"
          ></el-input>
          <p>
            <span>分钟</span
            >（学习时长低于要求将不被记录。设置为0则不开启限制。）
          </p>
        </div>
      </div>
      <p class="red" v-if="!$route.query.trainId">(该时间应小于{{ videoTxt }}，设置0为不生效)</p>
      <!-- 按钮 -->
      <div class="operation">
        <el-button class="succ_btn" @click="back">返回</el-button>
        <el-button type="success" class="submit_btn" @click="next">{{
          $route.query.trainId ? "完成" : "下一步"
        }}</el-button>
      </div>
    </div>
    <!-- 弹窗 -->
    <!-- 进度条 -->
    <el-dialog
      title="提示"
      :visible.sync="progressdialog.isshow"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-progress
        :text-inside="true"
        :stroke-width="24"
        :percentage="parseFloat(progressdialog.percentagenum.toFixed(2))"
        v-if="!isNaN(parseInt(progressdialog.percentagenum.toFixed(2)))"
        status="success"
      ></el-progress>
    </el-dialog>
  </div>
</template>

<script>
import OSS from "ali-oss"; //引入oss
import resourcereq from "@/api/resources";
import training from "@/api/trainingApi";

export default {
  data() {
    return {
      progressdialog: {
        isshow: false,
        percentagenum: 0,
      }, //进度弹窗
      textarea: "", //
      input1: "", //
      input2: "", //
      isShow: false,
      isedite: 0, //编辑模式。//0是新增模式，1是编辑模式 2是详情。
      filename: "支持mp4视频格式上传", //当前的文件名
      textFile: "", // 文件上传文件名
      onlufulename: "", //只有文件名字
      onlyfiletype: "mp4", //文件类型
      onlyfilesize: "", //只有文本大小
      value1: [], //范围时间数组
      textproduce: "", //课件介绍。
      database: "", //课件的basedata数据
      fileurl: "", //文件需要去请求的路劲拼接
      file: "", //文件对象拿去上传。
      timeValue: 0, // 学习最低时长
      vehicleTime: "23:59:00", // 默认时分秒
      videoTxt: "视频时长", // 获取时长
      client: null, //oss对象
      // 禁用当前前面的时间日期
      pickerOptions: {
        //禁用当前前面的时间日期
        disabledDate(time) {
          // 培训的限制
          const row = JSON.parse(localStorage.getItem("examRowTime"));
          if (row.begainTime) {
            const begainTime = row.begainTime;
            const endTime = row.endTime;
            return   time.getTime() < new Date(begainTime).getTime() ||time.getTime() > new Date(endTime).getTime()
          }
        },
      },
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
    };
  },
  methods: {
    back() {
      this.$parent.back();
    },
    numberChange() {
      if (typeof this.timeValue !== "number") {
        this.$message({
          message: "警告，考试作答时间必须为数字，单位为分钟",
          type: "warning",
        });
        this.timeValue = 0;
      }
    },
    async next() {
      //下一步
      //this.$parent.cutcoms(1);
      if (this.textarea == "") {
        this.$message.error("视频名称不能为空");
        return;
      }
      if (this.file == "" && this.isedite == 0) {
        this.$message.error("上传文件不能为空");
        return;
      }
      if (this.value1.length == 0) {
        this.$message.error("视频开放时间不能为空");
        return;
      }
      if (String(this.timeValue) == "") {
        this.timeValue = 0;
        this.$message.error("视频学习时长要求不能为空");
        return;
      }
      this.fileurl = `tibosi/${
        JSON.parse(localStorage.getItem("userlist")).hid
      }/${this.textarea}.${this.onlyfiletype}`;
      this.$parent.vUrl = this.fileurl;
      this.$parent.reqfrom.VideoName = this.textarea;
      this.$parent.reqfrom.VideoExplain = this.textproduce;
      this.$parent.reqfrom.Format = this.onlyfiletype;
      this.$parent.reqfrom.FileSize = this.onlyfilesize;
      this.$parent.reqfrom.BeginTime = this.value1[0];
      this.$parent.reqfrom.EndTime = this.value1[1];
      this.$parent.reqfrom.floorTime = this.timeValue;
      if (this.$route.query.trainId) {
        const obj = {
          trainId: this.$route.query.trainId,
        };
        const { data } = await training.getTrainByID(obj);
        if (data.Status == 200) {
          this.getData = data.Data.studentArr.map((item) => {
            item.UserID = item.StudentID;
            return item;
          });
          if (this.$route.query.state == 0) {
            let selectid = this.getData.map((item) => {
              return item.UserID;
            });
            this.$parent.reqfrom.userArr = JSON.stringify(selectid);
            let status = await this.checkfilename();
            if (status == 200) {
              // 上传前校验是否上传过，通过过校验服务器容量
              let parmas = {
                guid: JSON.parse(localStorage.getItem("userlist")).guid,
                userID: JSON.parse(localStorage.getItem("userlist")).userID,
                hid: JSON.parse(localStorage.getItem("userlist")).hid,
              };
              let ressts = await resourcereq.getOSS_STS(parmas);
              if (ressts.data.Status == 200 && ressts.data.Data.AccessKeyId) {
                // 判断当前医院的空间容量是否还有空闲 有的话返回秘钥
                this.progressdialog.isshow = true;
                let _this = this;
                this.client.multipartUpload(
                  this.$parent.$children[0].fileurl,
                  this.$parent.$children[0].file,
                  {
                    progress: async function (p, checkpoint) {
                      try {
                        _this.progressdialog.percentagenum = p * 100;
                        if (p == 1) {
                          _this.progressdialog.isshow = false;
                          _this.flang = true; // 成功状态
                          // 如果OSS进度条上传到百分百的情况下执行创建视频
                          let res = await resourcereq.createVideo(
                            _this.$parent.reqfrom
                          ); //创建视频
                          if (res.data.Status == 200) {
                            _this.$message.success("上传视频成功");
                            if(res.data.Data.videoID){
                              _this.addTrainBy(res.data.Data.videoID);
                            }
                            // _this.$parent.$parent.$children[0].getlist(); // 刷新主页列表
                          } else {
                            _this.$message.error(res.data.Data);
                          }
                          _this.$parent.back();
                        }
                      } catch (e) {
                        _this.$message.error("上传视频失败");
                      }
                    },
                  }
                );
                setTimeout(() => {
                  this.sundflag = false;
                }, 500);
              } else {
                this.$message.error(ressts.data.Data);
              }
            } else if (status == 201) {
              this.$message.warning("视频名称已存在，请重新命名");
              this.sundflag = false;
            } else {
              this.$message.warning("服务器出错了");
              this.sundflag = false;
            }
          } else {
            // 编辑
            this.savevideo();
            this.$message("修改成功");
            this.$router.push({
              path: "manage",
              query: {
                trainId: this.$route.query.trainId,
                // typeId: id,
              },
            });
          }
        } else {
          this.$message.error(data.Data);
        }
      } else {
        this.$parent.cutcoms(1);
      }
    },
    async addTrainBy(ID) {
      const obj = {
        trainId: this.$route.query.trainId,
        type: this.$route.query.type,
        typeId: ID,
      };
      const { data } = await training.addTrainByID(obj);
      if (data.Status == 200) {
        _this.$router.push({
          path: "manage",
          query: {
            trainId: this.$route.query.trainId,
            typeId: ID,
          },
        });
      } else {
        this.$message.error(data.Data);
      }
    },
    async init() {
      if (this.$route.query.state == 0) {
        // 新增
        let params = {
          // VideoName: "", // 视频名称查询
          guid: JSON.parse(localStorage.getItem("userlist")).guid,
          url: "/api/courseware/VideoManage/getVideoList",
          UserID: JSON.parse(localStorage.getItem("userlist")).userID,
          userID: JSON.parse(localStorage.getItem("userlist")).userID,
          pageIndex: 0,
          pageCount: 10,
          keyStr: ".show.bottom",
          hid: JSON.parse(localStorage.getItem("userlist")).hid,
        };
        const { data } = await resourcereq.getVideoList(params);
        if (data.Status == 200) {
          this.$parent.surplus =
            data.Data.result[3][0].courseSize - data.Data.result[1].countFile;
        }
        console.log(data);
      }
    },
    async checkfilename() {
      let parmas = {
        name: this.$parent.$children[0].fileurl,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        _examID: "",
      };
      let res = await resourcereq.checkfilename(parmas);
      return res.data.Status;
    },
    savevideo() {
      //修改视频信息，
      let selectid = this.getData.map((item) => {
        return item.UserID;
      });
      this.$parent.reqfrom.userArr = JSON.stringify(selectid);
      this.$parent.reqfrom.videoID = this.$parent.$parent.videoinfo.VideoID;
      resourcereq.SaveVideoInfo(this.$parent.reqfrom);
    },
    uploadPreview(file) {
      console.log(file);
      //文件上传，增加进度条，
      this.textFile = file.file.name;
      let filetype = file.file.name.split(".");
      filetype = filetype[filetype.length - 1]; //文件类型。
      this.onlyfiletype = filetype;
      this.onlufulename = file.file.name.substring(
        0,
        file.file.name.length - 4
      );
      this.onlyfilesize = file.file.size;
      if (filetype != "mp4" && filetype != "MP4") {
        this.$message({
          message: "视频格式只支持mp4格式",
          type: "warning",
        });
        this.textFile = "";
        this.$refs.upload.clearFiles(); //上传完了，再次点的时候是空的。
        return;
      } else if (file.size > 838860800) {
        this.$message({
          message: "文件大小不能超过800MB",
          type: "warning",
        });
        this.textFile = "";
        this.$refs.upload.clearFiles(); //上传完了，再次点的时候是空的。
        return;
      } else if (this.onlyfilesize > this.$parent.surplus) {
        // 4.11 产品更改可用容量不够上传前端拦截
        let str = this.$parent.surplus / 1024 / 1024;
        this.$message.error(
          `视频文件大小已超出容量,当前仅剩${str.toFixed(0)}M容量!`
        );
        this.textFile = "";
        this.$refs.upload.clearFiles(); //上传完了，再次点的时候是空的。
        return;
      }
      this.file = file.file;
      this.fileurl = `tibosi/${
        JSON.parse(localStorage.getItem("userlist")).hid
      }/${this.textarea}.${filetype}`;
      this.$parent.vUrl = this.fileurl;
      this.$refs.upload.clearFiles(); //上传完了，再次点的时候是空的。
    },
    // 点击获取当前默认时间
    obtainTime() {
      this.vehicleTime = this.$moment().format("HH:mm:ss");
    },
    async initOss() {
      //这里面进行请求sts
      let parmas = {
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
      };
      // let ressts = await resourcereq.getOSS_STS(parmas);
      let ressts = await resourcereq.getCoursewareOSS_STS(parmas);
      if (ressts.data.Status == 200 && ressts.data.Data.AccessKeyId) {
        this.client = new OSS({
          region: "oss-cn-shenzhen",
          accessKeyId: ressts.data.Data.AccessKeyId,
          accessKeySecret: ressts.data.Data.AccessKeySecret,
          bucket: "yingedu-video4",
          stsToken: ressts.data.Data.SecurityToken,
          secure: true,
          // accessKeyId: "LTAI5tPu8jJMiMybUXUSpMvp",
          // accessKeySecret: "GchIFvJQfMngvzb71mTh2HboOUrqIJ",
          // bucket: "yingedu-video4",
        });
      }
    },
    // 跳转查看上传视频格式
    toDocument() {
      let link = document.createElement("a");
      link.style.display = "none";
      let url = "https://khyt.tibosi.com/html/videoClass/videoteach/index.html";
      link.href = url;
      link.target = "_blank";
      link.click();
      //释放URL对象所占资源
      window.URL.revokeObjectURL(url);
      //用完即删
      // document.body.removeChild(link);
    },
    getVideoToken(file) {
      var url = URL.createObjectURL(file);
      var audioElement = new Audio(url);
      var duration;
      audioElement.addEventListener("loadedmetadata", () => {
        duration = parseInt(audioElement.duration); //时长为秒，取整
        this.videoTxt = this.$moment.utc(duration * 1000).format("HH:mm:ss");
      });
    },
  },
  computed: {
    filesize() {
      return function (Format, size) {
        size = (size / (1024 * 1024)).toFixed(3);
        return Format + "/" + size + "M";
      };
    },
    opentime() {
      return function (bigintime, endtime) {
        bigintime = this.$moment(bigintime).format("YYYY/MM/DD HH:mm");
        endtime = this.$moment(endtime).format("YYYY/MM/DD HH:mm");
        return bigintime + "-" + endtime;
      };
    },
  },
  activated() {
    this.init();
    this.initOss();
  },
  created() {
    if (this.$parent.$parent.videoinfo != "kong") {
      if (this.$parent.$parent.details == "details") {
        this.isedite = 2;
      } else {
        this.isedite = 1;
      }
      this.timeValue = this.$parent.$parent.videoinfo.floorTime;
      this.textarea = this.$parent.$parent.videoinfo.VideoName;
      this.value1[0] = this.$moment(
        this.$parent.$parent.videoinfo.BeginTime
      ).format("YYYY-MM-DD HH:mm");
      this.value1[1] = this.$moment(
        this.$parent.$parent.videoinfo.EndTime
      ).format("YYYY-MM-DD HH:mm");
      this.textproduce = this.$parent.$parent.videoinfo.VideoExplain;
    }
    //  this.obtainTime()
  },
};
</script>

<style lang="scss" scoped>
.baic_content {
  background-color: white;
  //  margin-top: 24px;
  min-width: 1527px;
  padding-bottom: 50px;
  border-radius: 4px 4px 4px 4px;
  h3 {
    display: inline-block;
    width: 100%;
    height: 20px;
    //  background: #cce7ff;
    border-radius: 4px 4px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    padding-top: 17px;
    padding-left: 24px;
  }
  .back_view {
    display: flex;
    align-items: center;
    margin-top: 30px;
    padding-right: 40px;
    h5 {
      display: inline-block;
      min-width: 142px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      text-align: left;
      line-height: 40px;
      padding-left: 20px;
    }
  }
  .bacle_input {
    display: flex;
    margin-top: 30px;
    padding-right: 40px;
    h5 {
      display: inline-block;
      min-width: 164px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      text-align: left;
      line-height: 40px;
      padding-left: 20px;
      &::before {
        content: "*";
        width: 20px;
        display: inline-block;
        color: #ff0000;
      }
      &:nth-child(3) {
        margin-left: 57px;
      }
    }
    .el-button {
      width: 162px;
      height: 40px;
      background: #1890ff;
      opacity: 1;
      border-radius: 4px;
      margin-left: 30px;
      color: #ffffff;
    }
  }
  .nonecessary {
    &::before {
      content: "" !important;
      width: 20px;
      display: inline-block;
      color: #ff0000;
    }
  }
  .check_textarea {
    width: 825px;
    ::v-deep .el-textarea__inner {
      width: 825px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      opacity: 1;
      border-radius: 4px;
    }
  }
  .check_input {
    width: 632px;
    ::v-deep .el-textarea__inner {
      width: 632px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      opacity: 1;
      border-radius: 4px;
    }
  }
  .check_produce {
    width: 832px;
    height: 200px;
  }
}
::v-deep .el-textarea .el-input__count {
  position: absolute;
  bottom: 12px;
  right: 18px;
}
::v-deep .el-textarea__inner {
  line-height: 28px !important;
}
.prompt {
  width: 147px;
  height: 28px;
  padding: 2px 1px;
}
.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 141px 0 70px 0;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
::v-deep .el-input__inner {
  border: 1px solid #dcdfe6;
}
.upoload {
  color: #1890ff !important;
  background-color: rgb(255, 255, 255) !important;
}
.datescope {
  width: 825px;
}
::v-deep .el-textarea__inner {
  height: 200px;
}
.vip_view {
  display: inline-block;
  min-width: 142px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  text-align: left;
  line-height: 40px;
  padding-left: 20px;
  &::before {
    content: "*";
    width: 20px;
    display: inline-block;
    color: #ff0000;
  }
}
.mg_40 {
  // padding-left: 14px !important;
  padding-left: 40px !important;
  text-align: right;
}

.upload_type {
  color: #1890ff;
  margin-left: 14px;
  line-height: 40px;
  font-size: 14px;
  &:link {
    color: #6aaaff;
    text-decoration: none;
    // border-bottom: 1px solid #1890ff;
  }
  &:hover {
    text-decoration: underline;
  }
  &:active {
    outline: none;
  }
}
.learning_time {
  display: flex;
  // align-items: center;
  margin-top: 30px;
  // padding-right: 40px;
  .input_time {
    display: flex;
    align-items: center;
    .el-input {
      width: 100px;
      margin-left: 4px;
    }
    p {
      span {
        margin: 0px 4px;
      }
    }
  }
}
.red {
  color: red;
  margin-left: 40px;
  margin-top: 10px;
}
</style>
